import { $api } from "@/services/api";

const state = {
  rejectedBillingCounter: 0,
};
const getters = {
  rejectedBillingCounter: (state) => state.rejectedBillingCounter,
};
const mutations = {
  updateRejectedBillingCounter(state, counter) {
    state.rejectedBillingCounter = counter;
  },
};
const actions = {
  async getRejectedBillingCounter({ commit }) {
    const poBillingRes = await $api.v_billing_items.get({
      billing_item_status: "Rejected",
      is_document_recipt: false,
      $select: ["id"],
      $limit: 1,
    });
    commit("updateRejectedBillingCounter", poBillingRes.total);
  },
};

export default { state, getters, mutations, actions };
